import { render, staticRenderFns } from "./ActiveUsersIcon.vue?vue&type=template&id=4c54542b&"
import script from "./ActiveUsersIcon.vue?vue&type=script&lang=js&"
export * from "./ActiveUsersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports